import parse from "html-react-parser"

import hintAlertIcon from "images/icons/icon-hint-alert.svg?raw"
import styles from "./incomplete_step_warning.module.scss"

interface Warning {
  type: "connection" | "configuration" | "dependency"
  message: string
  action: () => void
}

interface Props {
  warnings: Warning[]
}

export default function IncompleteStepWarning({ warnings }: Props) {
  if (!warnings.length) return null

  return (
    <div className={styles["warning-container"]}>
      {warnings.map((warning, index) => (
        <div key={index} className={styles["warning"]}>
          <span className={styles["warning-icon"]}>{parse(hintAlertIcon)}</span>
          <div className={styles["warning-text"]}>{warning.message}</div>
        </div>
      ))}
    </div>
  )
}

// Helper function to get warnings for a step
export const getStepWarnings = (step: any, stepType: string, dispatch: (action: any) => void): Warning[] => {
  if (!step?.isFromTemplate) return []

  const warnings: Warning[] = []

  // Check for trigger dependency (highest priority)
  if (step.disabled && step.isFromTemplate && stepType !== 'trigger') {
    warnings.push({
      type: "dependency",
      message: `Please add a trigger to finish setting up this ${stepType}.`,
      action: () => dispatch({ type: "SELECTING_TRIGGER_SERVICE" }),
    })
    return warnings
  }

  // Check for service connection
  if (step.needsConnection) {
    warnings.push({
      type: "connection",
      message: `There is no account attached here. Please edit this ${stepType}.`,
      action: () => dispatch({
        type: `CONNECTING_${stepType.toUpperCase()}_SERVICE`,
        value: step,
      })
    })
  }

  // Check for field configuration
  if (step.needsConfiguration && step.live_channel_id) {
    warnings.push({
      type: "configuration",
      message: `Missing fields. Please finish configuring this ${stepType} by going to edit.`,
      action: () => dispatch({
        type: `SELECTING_${stepType.toUpperCase()}_FIELDS`,
        value: step,
      })
    })
  }

  return warnings
}
